export default {
  methods: {
    domainTypeRender(state) {
      switch (state) {
        case 'PHR':
          return 'Presse hebodmadaire régionale'
        case 'PQR':
          return 'Presse quotidienne régionale'
        case 'PPR':
          return 'Presse professionnelle'
      }
      return 'Erreur'
    },
    cronShortRender(cronExpr) {
      if (!cronExpr) return '–'
      const parts = cronExpr.trim().split(/\s+/)
      if (parts.length !== 5) return cronExpr
      const [, , dom, month, dow] = parts
      if (dom === '*' && month === '*' && dow === '*') return 'Quot.'
      if (dom === '*' && month === '*' && dow !== '*') return 'Hebd.'
      if (dom !== '*' && month === '*' && dow === '*') return 'Mens.'
      if (dom !== '*' && month === '*/3') return 'Trim.'
      return 'Cron'
    },
    minutesAndSeconds(totalSeconds) {
      // 👇️ get number of full minutes
      const minutes = Math.floor(totalSeconds / 60);

      // 👇️ get remainder of seconds
      const seconds = totalSeconds % 60;

      function padTo2Digits(num) {
        return num.toString().padStart(2, '0');
      }
      // ✅ format as MM:SS
      return `${padTo2Digits(minutes)} min ${padTo2Digits(parseFloat(seconds).toFixed(0))} s`;
    }
  }
}
